
















import { Component, Vue } from 'vue-property-decorator';
import { curPref, Preferences } from '@/services/Preferences';

import SearchBox from '@/components/SearchBox.vue';
import NavBar from '@/components/NavBar.vue';
import DeviceList from '@/components/device/DeviceList.vue';
import BssList from '@/components/bss/BssList.vue';
import GroupList from "@/components/group/GroupList.vue";
import EnterpriseList from "@/components/group/EnterpriseList.vue";

@Component({
  components: {
    EnterpriseList,
    NavBar,
    DeviceList,
    BssList
  },
})
export default class Assets extends Vue {

  curSection:string = curPref.retrieve('v3-assets-cur-section', 'devices');
  error:string = '';

  bus = new Vue({});
  searchTerms: string = '';

  async mounted() {

    this.bus.$on('devices-search', (entId:string, groupId:string) => {
      this.curSection = 'devices';
      curPref.store('v3-assets-cur-section', this.curSection);
      if (entId && entId.length > 0 && groupId && groupId.length > 0) {
        this.searchTerms = `${entId}.${groupId}`;
      } else if (entId && entId.length > 0) {
        this.searchTerms = `${entId}.master`;
      }
    });
  }

  navbarClickHandler(newSection:string) {
    curPref.store('v3-assets-cur-section', newSection);
    this.curSection = newSection;
  }
}
